import { ModifierOptionContract, POSPriceListContract } from 'models'
import { PriceListData } from 'store/models/sellModels'
import { validateAvailability } from 'utilities/availability/availabilityHelper'

type GetItemPriceWithAppliedPriceListTuple = readonly [
    POSPriceListContract,
    number,
]
export const getItemPriceWithAppliedPriceList = (
    itemID: string,
    menuID: string | undefined,
    priceListData: PriceListData,
): GetItemPriceWithAppliedPriceListTuple => {
    const getBasePrice = () => {
        return (
            priceListData?.basePriceList.priceListItems?.find(
                (a) => a.itemID === itemID,
            )?.price ?? 0
        )
    }

    const definedMenuPrice = priceListData?.menuPriceListMap[menuID ?? '']
    // Check if there is defined availability
    if (
        definedMenuPrice &&
        validateAvailability(definedMenuPrice.priceListAvailabilities)
    ) {
        const pli = definedMenuPrice.priceListItems?.find(
            (a) => a.itemID === itemID,
        )
        if (pli) return [definedMenuPrice, pli.price ?? 0]
        else return [priceListData.basePriceList, getBasePrice()]
    } else {
        return [priceListData.basePriceList, getBasePrice()]
    }
}

export const getItemPrice = (
    /** itemID or ComboChoiceItem.ComboChoiceItemID */
    itemID: string,
    menuID: string | undefined,
    priceListData: PriceListData,
) => {
    const getBasePrice = () => {
        return (
            priceListData?.basePriceList.priceListItems?.find(
                (a) => a.itemID === itemID,
            )?.price ?? 0
        )
    }

    const definedMenuPrice = priceListData?.menuPriceListMap[menuID ?? '']
    // Check if there is defined availability
    if (
        definedMenuPrice &&
        validateAvailability(definedMenuPrice.priceListAvailabilities)
    ) {
        return (
            definedMenuPrice.priceListItems?.find((a) => a.itemID === itemID)
                ?.price ?? getBasePrice()
        )
    } else {
        return getBasePrice()
    }
}

export function getModifierOptionPrice(
    modifierOptionID: string,
    menuID: string | undefined,
    priceListData: PriceListData,
) {
    const definedMenuOption = priceListData?.menuPriceListMap[menuID ?? '']
    // Check of price list availability
    if (
        definedMenuOption &&
        validateAvailability(definedMenuOption.priceListAvailabilities)
    ) {
        return (
            definedMenuOption.priceListModifierOptions?.find(
                (a) => a.modifierOptionID === modifierOptionID,
            )?.price ??
            priceListData?.basePriceList.priceListModifierOptions?.find(
                (a) => a.modifierOptionID === modifierOptionID,
            )?.price ??
            0
        )
    }

    return (
        priceListData?.basePriceList.priceListModifierOptions?.find(
            (a) => a.modifierOptionID === modifierOptionID,
        )?.price ?? 0
    )
}

export function updatePriceListModifierGroupData(
    priceListData: PriceListData,
    cloneOption: ModifierOptionContract | undefined,
    price: number,
) {
    if (
        !priceListData.modifierGroupPriceListMap[
            cloneOption?.modifierGroupID ?? ''
        ]
    )
        priceListData.modifierGroupPriceListMap[
            cloneOption?.modifierGroupID ?? ''
        ] = {
            priceListModifierOptions: [],
            isBasePriceList: false,
            priceListItems: [],
        }
    priceListData.modifierGroupPriceListMap[
        cloneOption?.modifierGroupID ?? ''
    ]!.priceListModifierOptions!.push({
        modifierOptionID: cloneOption?.modifierOptionID,
        price: price,
    })
}

export function updatePriceListItemData(
    menuId: string,
    priceListData: PriceListData,
    itemId: string,
    price: number,
) {
    if (!priceListData.menuPriceListMap[menuId]) {
        priceListData.menuPriceListMap[menuId] = {
            priceListModifierOptions: [],
            isBasePriceList: false,
            priceListItems: [],
        }
    }
    const existingOption = priceListData.menuPriceListMap[
        menuId
    ]!.priceListItems?.find((c) => c.itemID === itemId)
    if (!existingOption) {
        priceListData.menuPriceListMap[menuId]!.priceListItems!.push({
            itemID: itemId,
            price: price,
        })
    }
}

export function updatePriceListModifierOptionData(
    menuId: string,
    priceListData: PriceListData,
    modifierOptionId: string,
    price: number,
) {
    if (!priceListData.menuPriceListMap[menuId]) {
        priceListData.menuPriceListMap[menuId] = {
            priceListModifierOptions: [],
            isBasePriceList: false,
            priceListItems: [],
        }
    }

    const existingOption = priceListData.menuPriceListMap[
        menuId
    ]!.priceListModifierOptions?.find(
        (c) => c.modifierOptionID === modifierOptionId,
    )
    if (!existingOption) {
        priceListData.menuPriceListMap[menuId]!.priceListModifierOptions!.push({
            modifierOptionID: modifierOptionId,
            price: price,
        })
    }
}
export function AddComboPriceToBasePriceListItemData(
    priceListData: PriceListData,
    comboChoiceItemID: string,
    price: number,
) {
    priceListData.basePriceList!.priceListItems!.push({
        itemID: comboChoiceItemID,
        price: price,
    })
}
